


import { ToastContainer, toast } from 'react-toastify';
import { Cookies } from 'react-cookie';
import { useEffect, useState, useRef } from "react";
import { ExportData } from "../../Exports/Export";
import * as XLSX from 'xlsx';
import { useNavigate } from "react-router-dom";


import EventMasterTable from './EventMasterTable';
import Footer from '../../Layout/FooterComponent';

const cookies = new Cookies();

const EventMasterForm = () => {

    const [edit, setEdit] = useState(false)
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(false);
    const [loading, setLoading] = useState(false)
    const [tableData, setTableData] = useState([])
    const [ColoredRow, setColoredRow] = useState(null);
    const [SessionClear, SetSessionClear] = useState(false);
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [filterList, setFilterList] = useState([]);
    const [filterData, setFilterData] = useState({
        SearchText: "",
        StartValue: "1",
        SearchFieldValue: "",
    })
    const [formData, setFormData] = useState({
        EventMasterID: "",
        EventCode: '',
        EventName: '',
        IsActive: true
    });
    const inputRefs = useRef([]);

    const Token = cookies.get('token')
    const LoginUserCode = cookies.get('loginUserCode')
    const Source = 'web';

    const getEventMasterData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        const data = {
            ...filterData,
            Token: cookies.get('token'),
            LoginUserCode: cookies.get('loginUserCode'),
            Source: 'web',
            Type: 'S',
            PageIndex: `${PageIndex}`
        }
        setLoading(true)
        await fetch('/api/MasterController/ShowEventMaster', {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        }
        ).then(async (response) => {
            let res = await response.json();
            if (res.status === 'SUCCESS') {
                setTableData(res)
                setLoading(false)
                inputRefs.current[res.focus].focus()
            }
            else if (res.message === "EXPIRED") {
                navigate("/login");
                SetSessionClear(true);
            }
            else if (res.status === "ERROR") {
                toast.error(res.message, {

                })
                setLoading(false)
                setTableData(res)
            }
        }).catch((err) => {
            toast.error(err.message, {

            })
            setLoading(false)
        }, [filterData])
    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevformdata) => ({ ...prevformdata, [name]: value }));
    }

    const handleClear = () => {
        setFormData({
            EventMasterID: '',
            EventCode: '',
            EventName: '',
            IsActive: true
        })
        filterData.SearchText = ''
        setColoredRow(null)
        setEdit(false)
        getEventMasterData()
    }

    const handleSubmit = async () => {
        let data = {
            ...formData, Token, LoginUserCode, Source
        }
        setIsLoading(true)
        await fetch('/api/MasterController/InsertUpdateEventMaster', {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        }).then(async (response) => {
            let res = await response.json();
            if (res.status === "SUCCESS") {
                setIsLoading(false);
                toast.success(res.message, {

                })
                handleClear();
                setIsLoading(false)
                setEdit(false);
                setColoredRow(null)

            }
            else if (res.message === "EXPIRED") {
                navigate("/login");

                SetSessionClear(true);
            }
            else if (res.status === "ERROR") {
                setIsLoading(false)
                toast.error(res.message, {

                })
                inputRefs.current[res.focus].focus()
            }
        }).catch((err) => {
            setIsLoading(false)
            toast.error(err, {

            })
        })
    };

    const handleEditData = async (id) => {
        const data = {
            Token: await cookies.get('token'),
            LoginUserCode: await cookies.get('loginUserCode'),
            Source: 'web',
            EventMasterID: id
        }
        await fetch(`/api/MasterController/EditEventMaster`, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        }).then(async (response) => {
            await setEdit(true)
            let res = await response.json()
            if (res.status === 'SUCCESS') {
                setColoredRow(id)
                await setFormData({ ...formData, EventMasterID: id, EventName: res.eventName, EventCode: res.eventCode, IsActive: res.isActive });
                inputRefs.current[res.focus].focus()
            }
            else if (res.message === "EXPIRED") {
                navigate("/login");

                SetSessionClear(true);
            }
            else if (res.status === "ERROR") {
                toast.error(res.message, {

                })
            }
        }).catch((err) => {
            toast.success(err, {

            })
        })
    }

    const getSearchingList = async () => {
        let data = {
            Token, LoginUserCode, PageName: 'EventMaster'
        }
        await fetch('/api/DashboardController/BindSearchingColumnList', {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            }
        }).then(async (response) => {
            let res = await response.json()
            if (res.status === 'SUCCESS') {
                let list = res.getSearchingList
                setFilterData({ ...filterData, SearchFieldValue: list[0].searchingValue })
                setFilterList(res.getSearchingList)
            }
            else if (res.message === "EXPIRED") {
                navigate("/login")
                SetSessionClear(true);
            }
            else if (res.status === "ERROR") {
                toast.error(res.message, {

                })
            }

        }).catch((err) => {
            toast.error(err.message, {

            })
        })
    };

    const handleChange1 = (event, value) => {
        getEventMasterData(value);
    };

    const downloadExcel = (records) => {
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.aoa_to_sheet([
            [records.hSrNo, records.hEventCode, records.hEventName,
            records.hCreatedBy, records.hCreatedDate, records.hIsActive, records.hModifiedBy, records.hModifiedDate,]
            ,
            ...records.getEventMasterData?.map((records) => [records.srNo, records.eventCode, records.eventName,
            records.createdBy, records.createdDate, records.isActive, records.modifiedBy, records.modifiedDate,
            ]),
        ]);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1');
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        saveExcelFile(excelBuffer, 'EventMaster.xlsx');
    };

    const saveExcelFile = (buffer, fileName) => {
        const data = new Blob([buffer], { type: 'application/octet-stream' });
        const url = window.URL.createObjectURL(data);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    };

    const handleDownloadExcel = async () => {
        const apiUrl = `/api/MasterController/ShowEventMaster`;
        const requestBody = {
            ...filterData,
            Token: cookies.get('token'),
            LoginUserCode: cookies.get('loginUserCode'),
            Type: 'E',
            PageIndex: '1'
        }
        const requestHeaders = {
            'Content-Type': 'application/json',
        };
        const records = await ExportData(apiUrl, requestBody, requestHeaders);
        if (records) {
            downloadExcel(records);
        }
    };


    useEffect(() => {
        getEventMasterData()
        document.title = "EventMaster"
        getSearchingList()
    }, [])

    return (
        <>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{'Event Master'}</h6>
                                </div>
                            </div>
                            <div className="form-box service-content-area">
                                <div className="row align-items-end">

                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Event Code <span className="Required">*</span></label>
                                            <input
                                                ref={ref => (inputRefs.current['txtEventCode'] = ref)}
                                                type="text"
                                                id="txtEventCode"
                                                className="form-control"
                                                placeholder="Event Code"
                                                autoComplete="off"

                                                maxLength='10'
                                                value={formData.EventCode}
                                                onChange={(e) => setFormData({ ...formData, EventCode: e.target.value })}

                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        inputRefs.current['txtEventName'].focus();
                                                    };
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Event Name <span className="Required">*</span></label>
                                            <input
                                                ref={ref => (inputRefs.current['txtEventName'] = ref)}
                                                id="txtEventName"
                                                type="text"
                                                className="form-control"
                                                placeholder="Event Name"
                                                autoComplete="off"
                                                maxLength='50'

                                                value={formData.EventName}
                                                onChange={(e) => setFormData({ ...formData, EventName: e.target.value })}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        inputRefs.current['chkActive'].focus();
                                                    };
                                                }}
                                            />
                                        </div>
                                    </div>


                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="form-check form-switch">
                                            <label
                                                className="form-check-label"
                                                htmlFor="activeCheckbox"
                                            >
                                                Active
                                            </label>
                                            <input
                                                ref={ref => (inputRefs.current['chkActive'] = ref)}
                                                className="form-check-input"
                                                type="checkbox"
                                                id="activeCheckbox"

                                                checked={formData.IsActive}
                                                onChange={(e) => setFormData({ ...formData, IsActive: e.target.checked })}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        handleSubmit()
                                                    };
                                                }}

                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-12 mt-4">
                                        <div className="lms-new-button text-center">
                                            {edit ? (isLoading ? <button className="button save-btn btn-disable" disabled={isLoading} >
                                                Please wait...
                                            </button> : <button className="button save-btn" onClick={handleSubmit}>
                                                <i className="bi bi-check-lg" /> Update & Save
                                            </button>) : (isLoading ? <button className="button save-btn btn-disable" disabled={isLoading} >
                                                Please wait...
                                            </button> : <button className="button save-btn" onClick={handleSubmit}>
                                                <i className="bi bi-check-lg" /> Save
                                            </button>)}
                                            <button className="button export-btn" onClick={handleDownloadExcel}>
                                                <i className="bi bi-download" /> Export
                                            </button>
                                            <button className="button reset-btn" onClick={handleClear}>
                                                <i className="bi bi-arrow-clockwise" /> Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <EventMasterTable loading={isLoading} handleReset={handleClear} setColoredRow={setColoredRow} ColoredRow={ColoredRow} currentPageNo={currentPageNo} filterList={filterList} filterData={filterData} setFilterData={setFilterData} tableData={tableData} getEventMasterData={getEventMasterData} handleChange={handleChange1} handleEditData={handleEditData} />
            <ToastContainer theme='colored' />
            <Footer/>
        </>
    )
}
export default EventMasterForm;